import React from 'react';
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'
import {Link} from 'react-router-dom'

import config from '../../config.js'

import {fetchDataIfReady, fetchDataIfUndefined} from 'Skelet/src/modules/fetch.action.js'


class StartBlogs extends React.Component {

  componentWillMount() {
    if(this.props.session_token) {
      this.props.fetchDataIfReady(config.api_token, "startblogs_overview", "GET", config.api_url+"/blogs?t="+this.props.session_token, undefined, null, false, false, false, "blogs_overview");
    } else {
      this.props.fetchDataIfReady(config.api_token, "startblogs_overview", "GET", config.api_url+"/blogs", undefined, null, false, false, false, "blogs_overview");
    }
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.session_token) {
      this.props.fetchDataIfUndefined(config.api_token, "startblogs_overview", "GET", config.api_url+"/blogs?t="+nextProps.session_token, undefined, null, false, false, false, "blogs_overview");
    } else {
      this.props.fetchDataIfUndefined(config.api_token, "startblogs_overview", "GET", config.api_url+"/blogs", undefined, null, false, false, false, "blogs_overview");
    }
  }

  render() {
    let cards = null, page_cards = this.props.apiData["startblogs_overview"];

    // todo: "Clublid Blog". gewoon in api al filteren/loopen en dan dus cached terug geven met is_admin oid. één query voor club, en één voor admin blogs.
    if(page_cards !== undefined) {
      cards = page_cards.data.map(function(item, i) {
        if(i > 2) return null;
        let item_link = "/blog/"+item.title.replace(/ /g, "-").replace("#-", "").replace(/#/g, "").replace(/,/g, "")+"-"+item.ref_id;

        return <div key={"1k"+i} className="col-3"><div className="card thumbnail-card">
          <div className="image-container"><Link to={item_link} onClick={() => document.getElementById("main").scrollIntoView(true)}><img src={"https://images.dieet.club/"+item.img_fn} alt={"Dieet.Club | "+item.title} /></Link></div>
          <h3><Link to={item_link} onClick={() => document.getElementById("main").scrollIntoView(true)}>{item.title}</Link></h3>
          <h4>Dieet.Club Blog</h4>
        </div></div>;
      });
    }

    return (
      <div>
        {page_cards !== undefined && page_cards.data[0] !== undefined && cards}
      </div>
    );
  }

}


function mapStateToProps(state) {
  let session_token = null;
  if(state.apiData["login"] !== undefined && (state.apiData["login"]["data"]["token"] !== undefined || state.apiData["login"]["data"]["token"] === null)) {
    session_token = state.apiData["login"]["data"]["token"];
  }
  return {
    session_token: session_token,
    apiData: state.apiData,
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    fetchDataIfReady,
    fetchDataIfUndefined,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(StartBlogs)



// WEBPACK FOOTER //
// ./src/containers/StartPages/StartBlogs.js